import { computed } from "vue";
import { useRoute } from "vue-router";

export const HELP_HOME_URL = "https://forkto.com/help/";

/**
 * Resolve the help article for a route: its own `meta.helpUrl`, else the
 * nearest ancestor's (so `/reports/meats` and `/products/:id` inherit their
 * section's article), else the help home. Pure so it can be tested and reused
 * by anything that has a route object, not only components.
 */
export function resolveHelpForRoute(route) {
    const matched = route?.matched || [];
    for (let i = matched.length - 1; i >= 0; i -= 1) {
        const url = matched[i]?.meta?.helpUrl;
        if (url) {
            return {
                url,
                // The nearest ancestor that owns the article names it; a detail
                // page's own title ("Menu Editor") is still a fine label.
                title: route?.meta?.title || matched[i]?.meta?.title || "",
                specific: true
            };
        }
    }
    return { url: HELP_HOME_URL, title: "", specific: false };
}

/**
 * Context-aware help for the current page. One global Help entry reads this,
 * so every view that sets `meta.helpUrl` on its route is covered without
 * carrying its own "Help docs" link.
 */
export function useContextHelp() {
    const route = useRoute();
    const help = computed(() => resolveHelpForRoute(route));

    function openHelp() {
        window.open(help.value.url, "_blank", "noopener,noreferrer");
    }

    return { help, openHelp };
}
